import { InputNumber, Modal, Typography } from "antd";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import { UpdateRankAPI } from "../../API/UpdateRankAPI";
import { MOVE_RANK_INITIAL_OBJECT } from "../../screens/Rankings/RankingsUtils";
const { Text } = Typography;

export const MoveRank = ({
  open,
  setOpen,
  selectedRow,
  listData,
  getRankingDataFun,
  dragableState,
  messageToast,
  setSelectedRowKeys,
  setSelectedRow,
}) => {
  const [inputElements, setInputElements] = useState(MOVE_RANK_INITIAL_OBJECT);

  function formValidation() {
    let isValid = true;
    let obj = { ...inputElements };

    if (inputElements.rank === "") {
      isValid = false;
      obj.errorFieds.rank = "Rank is required";
    } else {
      obj.errorFieds.rank = "";
    }

    setInputElements(obj);

    return isValid;
  }

  async function applyFun() {
    if (formValidation()) {
      if (dragableState === true) {
        if (
          selectedRow?.id &&
          selectedRow?.id !== "" &&
          selectedRow?.id !== null
        ) {
          const activeInd = listData.findIndex(
            (i) => i.rank === selectedRow?.rank,
          );
          const overInd = listData.findIndex(
            (i) => i.rank === inputElements.rank,
          );

          if (listData[activeInd]?.rank !== listData[overInd]?.rank) {
            let arr = [];
            if (activeInd > overInd) {
              for (let index = overInd; index < activeInd; index++) {
                const element = listData[index].spec_concat;
                arr.push(element);
              }
            } else {
              for (let index = activeInd + 1; index <= overInd; index++) {
                const element = listData[index].spec_concat;
                arr.push(element);
              }
            }

            const bodyData = {
              flight_model: localStorage.getItem("flight_model"),
              old_rank: listData[activeInd].rank,
              new_rank: listData[overInd].rank,
              spec_list: arr,
              selected_spec: listData[activeInd]?.spec_concat,
            };

            updateRankFun(bodyData);
          } else {
            messageToast("error", "Selected Ranks are same");
          }
        } else {
          messageToast("warning", "To Move the rank, you must select one Row");
        }
      } else {
        messageToast(
          "warning",
          "To change the rank, you must clear all filters applied",
        );
      }
    }
  }

  function cancelFun() {
    setInputElements(MOVE_RANK_INITIAL_OBJECT);
    setOpen(false);
  }

  async function updateRankFun(bodyData) {
    await UpdateRankAPI.dragandupdateRank(bodyData)
      .then((res) => {
        if (res.data?.status === true) {
          setInputElements(MOVE_RANK_INITIAL_OBJECT);
          setSelectedRowKeys([]);
          setSelectedRow({});
          getRankingDataFun();
          messageToast("success", res.data?.message);
        } else {
          messageToast("error", res.data?.message);
          if (res.data?.reload === true) {
            setTimeout(() => {
              window.location.reload();
            }, "2000");
          }
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
      })
      .finally(() => setOpen(false));
  }

  return (
    <Modal
      open={open}
      okText="Move"
      cancelText="Cancel"
      onCancel={() => cancelFun()}
      onOk={applyFun}
    >
      <div style={{ padding: "10px" }}>
        <div
          style={{ marginBottom: "20px", borderBottom: "solid 1px #80808047" }}
        >
          <Title level={5}>Move to</Title>
        </div>
        <div style={{ marginBottom: "15px" }}>
          <label>Rank</label>
          <InputNumber
            status={!inputElements.errorFieds.rank ? "" : "error"}
            style={{ display: "block", width: "100%" }}
            min={1}
            value={inputElements.rank}
            onChange={(e) => {
              const value = e;
              setInputElements((prev) => ({
                ...prev,
                rank: value,
                errorFieds: {
                  ...prev.errorFieds,
                  rank: !value ? "Rank is required" : "",
                },
              }));
            }}
          />
          <Text type="danger" italic>
            {inputElements.errorFieds.rank}
          </Text>
        </div>
      </div>
    </Modal>
  );
};
